{
  "title": {
    "documents": "Все документы",
    "reports": "Все отчёты"
  },
  "sections": {
    "label": "Разделы",
    "documents": "Документы",
    "reports": "Отчёты"
  },
  "search": "Поиск",
  "views": {
    "label": "Вид",
    "table": "Таблица",
    "grid": "Карточки",
    "columns": "Колонки"
  },
  "create": {
    "button": "Создать",
    "folder": "Создать папку",
    "upload": "Загрузить документ"
  },
  "columns": {
    "name": "Название",
    "type": "Тип",
    "size": "Размер",
    "createdAt": "Создан",
    "updatedAt": "Изменён",
    "createdBy": "Автор",
    "visibility": "Доступ",
    "actions": "Действие"
  },
  "types": {
    "folder": "Папка",
    "pdf": "Pdf",
    "word": "Word",
    "excel": "Excel",
    "powerpoint": "PowerPoint",
    "image": "Изображение",
    "csv": "CSV",
    "other": "Другое"
  },
  "visibility": {
    "private": "Личный",
    "selected": "Выбранные",
    "public": "Общий",
    "sharedCount_one": "{{count}} пользователь",
    "sharedCount_few": "{{count}} пользователя",
    "sharedCount_many": "{{count}} пользователей",
    "sharedCount_other": "{{count}} пользователя"
  },
  "visibilityOption": {
    "private": "Личный документ",
    "selected": "Выбранные",
    "public": "Общий"
  },
  "visibilityHint": {
    "private": "Видите только вы и администраторы",
    "selected": "Видите вы, администраторы и выбранные пользователи",
    "public": "Видят все сотрудники с доступом к разделу"
  },
  "sort": {
    "label": "Сортировка",
    "name": "Название (А–Я)",
    "-name": "Название (Я–А)",
    "-updatedAt": "Недавно изменённые",
    "updatedAt": "Давно изменённые",
    "-createdAt": "Новые",
    "createdAt": "Старые",
    "-size": "Размер: по убыванию",
    "size": "Размер: по возрастанию",
    "type": "По типу",
    "-type": "По типу (обратно)",
    "asc": "по возрастанию",
    "desc": "по убыванию",
    "by": "Сортировать по: {{column}}"
  },
  "grid": {
    "author": "Создал: {{name}}",
    "files_one": "{{count}} файл",
    "files_few": "{{count}} файла",
    "files_many": "{{count}} файлов",
    "files_other": "{{count}} файла",
    "edited": "Изменён: {{date}}"
  },
  "actions": {
    "menu": "Действия",
    "open": "Открыть",
    "download": "Скачать",
    "rename": "Переименовать",
    "move": "Переместить",
    "visibility": "Изменить доступ",
    "delete": "Удалить"
  },
  "inFolder": "{{folder}}",
  "rootFolder": "{{section}} (корневая папка)",
  "upload": {
    "title": "Загрузка документа",
    "subtitle": "Загрузить новый документ в систему",
    "drop": "Загрузить документ",
    "dropActive": "Перетащите файл сюда",
    "hint": "{{types}} — до {{size}}",
    "uploading": "Загрузка...",
    "uploadingProgress": "Загрузка... {{percent}}%",
    "addMore": "Добавить ещё",
    "name": "Название документа",
    "folder": "Папка",
    "visibility": "Уровень доступа",
    "users": "Пользователи",
    "usersPlaceholder": "Выберите пользователей",
    "usersEmpty": "Пользователи не найдены",
    "usersRequired": "Выберите хотя бы одного пользователя",
    "removeFile": "Убрать файл «{{name}}»",
    "downloadFile": "Скачать файл «{{name}}»",
    "saved_one": "Документ загружен",
    "saved_few": "Загружено {{count}} документа",
    "saved_many": "Загружено {{count}} документов",
    "saved_other": "Загружено {{count}} документа",
    "savedText": "Добавлено в папку «{{folder}}»",
    "rejectedType": "«{{name}}» — файлы этого типа не принимаются",
    "rejectedSize": "«{{name}}» — файл больше {{size}}",
    "failed": "«{{name}}» не загружен",
    "pageDrop": "Перетащите файлы сюда для загрузки"
  },
  "folder": {
    "createTitle": "Создать папку",
    "createSubtitle": "Новая папка в разделе «{{section}}»",
    "name": "Название папки",
    "namePlaceholder": "Например: Отчёты за 2026 год",
    "created": "Папка создана"
  },
  "rename": {
    "title": "Переименовать",
    "name": "Название",
    "saved": "Переименовано"
  },
  "move": {
    "title": "Переместить",
    "subtitle": "Новое место для «{{name}}»",
    "target": "Папка",
    "saved": "Перемещено"
  },
  "visibilityModal": {
    "title": "Изменить доступ",
    "saved": "Доступ изменён"
  },
  "delete": {
    "documentTitle": "Удалить документ?",
    "documentText": "Документ «{{name}}» будет удалён.",
    "folderTitle": "Удалить папку?",
    "folderText": "Папка «{{name}}» будет удалена.",
    "folderTextNonEmpty": "Папка «{{name}}» будет удалена вместе с файлами ({{documents}}) и папками ({{folders}}) внутри.",
    "done": "Удалено"
  },
  "access": {
    "title": "Доступ",
    "count": "{{count}}",
    "author": "Автор",
    "view": "Просмотр",
    "unknown": "Неизвестный пользователь"
  },
  "columnsView": {
    "meta": "{{type}} документ - {{size}}",
    "download": "Скачать {{ext}}",
    "noPreview": "Предпросмотр недоступен"
  },
  "preview": {
    "download": "Скачать",
    "frame": "Просмотр документа «{{name}}»"
  },
  "empty": {
    "documents": "Документов нет",
    "reports": "Отчётов нет",
    "text": "Документов пока нет. Нажмите «Загрузить документ».",
    "textReadonly": "Здесь пока нет документов.",
    "folderTitle": "Папка пуста",
    "folderText": "В этой папке пока нет документов.",
    "searchTitle": "Ничего не найдено",
    "searchText": "По запросу «{{q}}» ничего нет.",
    "clear": "Очистить"
  },
  "notFound": {
    "title": "Папка не найдена",
    "text": "Папка удалена или недоступна вам.",
    "back": "В корневую папку"
  },
  "error": {
    "load": "Не удалось загрузить данные",
    "retry": "Повторить",
    "generic": "Произошла ошибка"
  },
  "common": {
    "cancel": "Отмена",
    "save": "Сохранить",
    "close": "Закрыть",
    "breadcrumbs": "Путь к папке",
    "dash": "-"
  }
}
